import { appConfig } from '@app/config/appConfig';

function getPendo(): Pendo | undefined {
  return globalThis.pendo;
}

let isPendoInitialized = false;

export const initializePendo = (visitor: PendoVisitor, account: PendoAccount) => {
  const pendo = getPendo();
  if (pendo === undefined) {
    console.error('Pendo script not loaded');
    return;
  }

  if (isPendoInitialized) {
    pendo.identify({
      visitor,
      account,
    });
  } else {
    pendo.initialize({
      apiKey: appConfig.thirdParties.pendoApiKey,
      visitor,
      account,
    });
    isPendoInitialized = true;
  }
};
